import { Intent } from '@blueprintjs/core';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { 
  getSidebar, 
  getPermohonanID,
} from '../utils/storage';

export interface UIToast {
  intent: Intent,
  message: string,
}

interface UIState {
  dark?: boolean,
  loading: boolean,
  loadingCount: number,
  toast: UIToast,
  sidebar: SidebarState,
  client: Client,
  permohonanID: number,
}

const initialState: UIState = {
  dark: false,
  loading: false,
  loadingCount: 0,
  toast: { intent: 'none', message: '' },
  sidebar: getSidebar() || 'expand',
  client: {
    permohonanID:0,
  },
  permohonanID: 0,
};

const getInitialState = (): UIState => {
  let permohonanID = 0;
  const permohonanIDStore = getPermohonanID();
  if(permohonanIDStore != null){
    permohonanID = permohonanIDStore;
  }

  return { 
    ...initialState, 
    permohonanID: permohonanID,
  };
};

export const uiSlice = createSlice({
  name: 'settings',
  initialState: getInitialState(),
  reducers: {
    setDarkMode: (state, { payload }: PayloadAction<boolean>) => {
      state.dark = payload;
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loadingCount = payload ? state.loadingCount + 1 : state.loadingCount - 1;
      state.loading = state.loadingCount > 0;
    },
    setMessage: (state, { payload }: PayloadAction<UIToast>) => {
      state.toast = payload;
    },
    setSidebar: (state, { payload }: PayloadAction<SidebarState>) => {
      state.sidebar = payload;
    },
    setClient: (state, { payload }: PayloadAction<Client>) => {
      state.client = payload;
    },
    setPermohonanID: (state, { payload }: PayloadAction<number>) => {
      state.permohonanID = payload;
    },
  },
});

export const { 
  setDarkMode,
  setLoading,
  setMessage,
  setSidebar,
  setClient,
  setPermohonanID,
} = uiSlice.actions;

export default uiSlice.reducer;
